
import { useMemo } from 'react';

import { connect, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { isThreeDSFromPath } from '@share/utils';

import LogInNav from '../log-in-nav/component';
import Navbar from '../nav-bar/navbar';
import { ILoginState } from '@share/store/slices';

interface IProps extends RouteComponentProps {
}

function ApplicationHeaderComponent(props: IProps) {
  const { history } = props;

  const isThreeDS = useMemo(() => isThreeDSFromPath(history), [history]);

  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const userStorage = loginStore.user;

  if (isThreeDS) {
    return null;
  }

  if (userStorage?.accessToken) {
    return <LogInNav />;
  } else {
    return <Navbar />;
  }
}

const ApplicationComponentWithRouter = withRouter(ApplicationHeaderComponent);

export const ApplicationHeader = connect()(ApplicationComponentWithRouter);
